/*
 * @Descripttion: 
 * @version: 
 * @Author: Ray
 * @Date: 2024-04-03 10:37:44
 * @LastEditors: Ray
 * @LastEditTime: 2024-04-03 13:36:20
 */
import {
    isError,
    extractErrorStack,
    getLocationHref,
    getTimestamp,
    unknownToString,
    isWxMiniEnv,
    Severity,
    getCurrentRoute
} from '@zyf2e/monitor-utils'
import { transportData } from '@zyf2e/monitor-core'
import { breadcrumb } from '@zyf2e/monitor-core'

// interface LogTypes {
//   message: TNumStrObj
//   tag?: TNumStrObj
//   level?: Severity
//   ex?: Error | any
//   type?: string
// }

/**
 *
 * 自定义上报事件
 * @export
 * @param {LogTypes} { message = 'emptyMsg', tag = '', level = Severity.Critical, ex = '' }
 */
export function log({ message = 'emptyMsg', tag = '', level = Severity.Critical, ex = '', type = "LOG_ERROR" }) {
    let errorInfo = {}
    if (isError(ex)) {
        errorInfo = extractErrorStack(ex, level)
    }
    const errorJson = message[message.length - 1].error || {}
    const { params, baseURL, url, data } = errorJson
    const error = {
        type,
        level,
        errorJson: unknownToString(errorJson),
        errorParams: unknownToString(params),
        errorBaseURL: baseURL,
        errorUrl: url,
        errorData: unknownToString(data),
        message: unknownToString(message),
        name: 'MITO.log',
        customTag: unknownToString(tag),
        time: getTimestamp(),
        stack: "",
        url: isWxMiniEnv ? getCurrentRoute() : getLocationHref(),
        ...errorInfo
    }
    breadcrumb.push({
        type: "Customer",
        category: breadcrumb.getCategory("Customer"),
        level: Severity.fromString(level.toString()),
        data: {}
    })
    transportData.send(error);
}
